import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f528fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("COMING SOON")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_n_h4 = _resolveComponent("n-h4")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_ctx.mission.title)
    ? (_openBlock(), _createBlock(_component_n_card, {
        key: 0,
        class: _normalizeClass(["live-mission", `cover-${_ctx.coverIndex}`]),
        hoverable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_space, {
            vertical: "",
            justify: "space-between",
            style: {"height":"100%"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_n_h2, { style: {"margin-bottom":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_text, {
                      class: "live-mission__title",
                      style: {"text-transform":"uppercase","font-family":"'syncopate'"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.mission.title), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_h4, { style: {"margin-top":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_text, {
                      type: "primary",
                      class: "live-mission__title",
                      style: {"text-transform":"uppercase","font-family":"'syncopate'"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.mission.subtitle), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_n_text, { class: "live-mission__description" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mission.description), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_n_space, { justify: "right" }, {
                default: _withCtx(() => [
                  (_ctx.mission.buttonTitle)
                    ? (_openBlock(), _createBlock(_component_n_button, {
                        key: 0,
                        onClick: _ctx.triggerRoute,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.mission.buttonTitle), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_n_button, {
                        key: 1,
                        type: "primary",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}